import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { fetchData, toasterrormsg, toastsuccessmsg } from '../../../../reusable'
import { Tr } from '../../../../_metronic/i18n/Tr';

export function ForgotPassword() {
  const t = Tr();
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState("")
  const [email, setEmail] = useState("")

  const validateEmail = async () => {

    if (email.trim() === "" || email.trim() === null || email.trim() === undefined) {
      setHasErrors(t("Email Address Is Required"))
    }
    else if (!email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}(?:\.[A-Z]{2,})?$/i)) {
      setHasErrors(t("Enter Valid Email Address"))
    }
    else {
      forgotpasswordapicall()
    }
  }

  const forgotpasswordapicall = async () => {
    var param: any = {
      email: email
    }
    var response: any = await fetchData("public/forgotpassword", param)

    if (response.status == "200") {

      localStorage.setItem("vendorId", response.data[0]['vendorId'])
      toastsuccessmsg(t("OTP Send Successfully"))

      setTimeout(() => {
        navigate("../reset-password");
      }, 1500);

    }
    else {
      setLoading(false)
      toasterrormsg(response.message)
    }
  }

  return (
    <>
      <ToastContainer />

      <div
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        id='kt_login_password_reset_form'
      >
        <div className='text-center mb-10'>
          {/* begin::Title */}
          <h1 className='text-dark fw-bolder mb-3'>{t('Forgot Password ?')}</h1>
          {/* end::Title */}

          {/* begin::Link */}
          <div className='text-gray-500 fw-semibold fs-6'>
            {t('Enter your Email Address to reset your password.')}
          </div>
          {/* end::Link */}
        </div>
        {/* end::Title */}

        {/* begin::Form group */}
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-gray-900 fs-6 required'>{t('Email')}</label>
          <input
            type='email'
            placeholder={t('Email')}
            autoComplete='off'
            value={email}
            onChange={(e: any) => { setEmail(e.target.value); }}
            className={'form-control bg-transparent'}
          />
          <span className='text-danger mt-3'>{hasErrors}</span>

        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
          <button type='button' id='kt_password_reset_submit' className='btn btn-primary me-4' onClick={() => validateEmail()}>
            <span className='indicator-label'>{t('Submit')}</span>
            {loading && (
              <span className='indicator-progress'>
                {t('Please wait...')}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
          {' '}
        </div>
        {/* end::Form group */}
      </div>
    </>
  )
}
